const within24Hours = (date, timeNow) => {
  const twentyFourHoursFromNow = new Date(
    timeNow.getTime() + 24 * 60 * 60 * 1000
  );
  return date > timeNow && date < twentyFourHoursFromNow;
};

export const getInitialSeconds = banners => {
  const promo = Array.isArray(banners) ? banners[0] : null;
  if (!promo || !promo.endDate) return 0;
  const timeNow = new Date();
  const endTime = new Date(promo.endDate);

  if (!within24Hours(endTime, timeNow)) return 0;
  return Math.max(
    0,
    Math.floor((endTime.getTime() - timeNow.getTime()) / 1000)
  );
};
